import React, { useMemo } from "react";
import { IconButton, LinearProgress, Paper, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import DataTable from "react-data-table-component";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import { Link } from "react-router-dom";

const sortIcon = <ArrowDownward />;

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
        table: {
            minWidth: 650,
        }
    },
    btn: {
        margin: theme.spacing(4)
    }
}));

const ZoleList = ({ planList, editPlan, deletePlan, check, singlePlanById }) => {
    const classes = useStyles();

    const heading = [
        {
            name: "Sr. No",
            wrap: true,
            sortable: true,
            cell: (row, index) => index + 1,
        }, {
            name: "Starcoin",
            selector: "zole",
            wrap: true,
            sortable: true,
        }, {
            name: "Price",

            wrap: true,
            sortable: true,
            cell: (planList) => (
                <p>
                    {"RS " + planList.price}
                </p>
            )
        }, {
            name: "Bonus",
            selector: "bonus",
            wrap: true,
            sortable: true,
        }, {
            name: "Apple Id",
            selector: "appleId",
            wrap: true,
            sortable: true,
        }, {
            name: "Action",
            wrap: true,
            center: true,
            cell: (planList) => (
                <div>
                    <Link to={"/dashboard/create-zole/" + planList._id}>
                        <IconButton
                            edge="end"
                            aria-label="edit"

                        >
                            <EditIcon color="primary" />
                        </IconButton>
                    </Link>
                    <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => {
                            deletePlan(planList._id)
                        }}
                    >
                        <DeleteIcon color="primary" />
                    </IconButton>
                </div>
            )
        }
    ];

    const safeData = Array.isArray(planList) ? planList : [];

    const columns = useMemo(
        () => [
            {
                name: "Sr. No",
                wrap: true,
                sortable: true,
                cell: (row, index) =>
                    typeof index === "number" ? <div>{index + 1}</div> : <div>{safeData.findIndex((r) => r._id === row._id) + 1}</div>,
                width: "90px",
            },
            {
                name: "Starcoin",
                selector: (row) => row.zole ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Price",
                wrap: true,
                sortable: true,
                cell: (row) => <p>{"RS " + (row?.price ?? 0)}</p>,
            },
            {
                name: "Bonus",
                selector: (row) => row.bonus ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Apple Id",
                selector: (row) => row.appleId ?? "-",
                wrap: true,
                sortable: true,
            },
            {
                name: "Action",
                wrap: true,
                center: true,
                cell: (row) => (
                    <div style={{ display: "flex", gap: 8 }}>
                        <Link to={`/dashboard/create-zole/${row._id}`}>
                            <IconButton edge="end" aria-label="edit">
                                <EditIcon color="primary" />
                            </IconButton>
                        </Link>

                        <IconButton edge="end" aria-label="delete" onClick={() => deletePlan && deletePlan(row._id)}>
                            <DeleteIcon color="primary" />
                        </IconButton>
                    </div>
                ),
                width: "160px",
            },
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [deletePlan, safeData]
    );

    return (
        <div>
            {!planList ? (
                <LinearProgress color="primary" />
            ) : (
                <Paper className={classes.paper} square>
                    <Link to='/dashboard/create-zole'><Button variant="contained" color="primary" className={classes.btn}>Add Starcoin</Button></Link>
                    {!check ?
                        <DataTable
                            columns={columns}
                            data={safeData}
                            noHeader
                            pagination
                            paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                            // COMMENT OUT sortIcon while debugging. If you re-enable, ensure it's a React node.
                            // sortIcon={sortIcon}
                            striped
                            highlightOnHover
                            responsive
                        />
                        : ''}
                </Paper>
            )}
        </div>
    );
};

export default ZoleList;
